import styled from 'styled-components';
import { maxWidth, minWidth } from 'config/constants';

const PANEL_BREAKPOINT = 1540;

export const StyledMachineStatsCardBase = styled.div`
  flex: 1 1 0;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  background-color: ${(props): string => props.theme.kcc.colors.WHITE};
  border: 2px solid ${(props): string => props.theme.kcc.colors.GRAY_100};
  border-radius: ${(props): string => `${props.theme.kcc.borderRadius.OVERLAYS}px`};
  padding: ${(props): string => props.theme.kcc.spacing.MD} ${(props): string => props.theme.kcc.spacing.LG};
  overflow: hidden;

  ${maxWidth.l} {
    min-width: 0;
    width: 100%;
  }

  ${minWidth.m} {
    height: auto;
    max-height: 552px;
  }

  ${minWidth.l} {
    height: auto;
  }

  ${minWidth.custom(PANEL_BREAKPOINT)} {
    height: auto;
    max-height: 552px;
  }

  .machine-stats-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${(props): string => props.theme.kcc.spacing.BASE};
    flex-shrink: 0;
  }

  .machine-stats-card__body {
    display: flex;
    flex-direction: row;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  .machine-stats-card__left {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    ${minWidth.m} {
      max-width: 50%;
    }

    ${minWidth.l} {
      max-width: none;
    }

    ${minWidth.custom(PANEL_BREAKPOINT)} {
      max-width: 50%;
    }
  }

  .machine-stats-card__empty {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 0;
    padding: 90px 0;
  }

  .machine-stats-card__right {
    display: none;
    min-width: 0;
    padding-left: ${(props): string => props.theme.kcc.spacing.LG};
    overflow: hidden;

    ${minWidth.m} {
      display: flex;
      flex-direction: column;
      flex: 1 1 0;
    }

    ${minWidth.l} {
      display: none;
    }

    ${minWidth.custom(PANEL_BREAKPOINT)} {
      display: flex;
      flex-direction: column;
      flex: 1 1 0;
    }
  }

  .machine-stats-card__title {
    font-size: ${(props): string => `${props.theme.kcc.typography.FONT_SIZE.HEADING_4}px`};
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    margin: 0;
  }

  .machine-stats-card__title-icon {
    width: 24px;
    height: 24px;
    color: ${(props): string => props.theme.kcc.colors.BLACK};
    cursor: pointer;
    flex-shrink: 0;

    svg {
      width: 24px;
      height: 24px;
    }
  }
`;
